import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getAutopayEnabled, getUser } from 'reducers';
import { autopay } from '../actions';
import Box from 'common/Box';
import Warning from 'notifications/Warning';
import styles from './index.module.css';
import toggle_on from '../toggle/toggle_on.svg';
import toggle_off from '../toggle/toggle_off.svg';

export const Autopay = ({ userId, autopayEnabled, autopay }) => (
  <React.Fragment>
    <Box>
      <div className={styles.Autopay}>
        <span className={styles.enabled}>
          {autopayEnabled ? 'ON' : 'OFF'}
        </span>
        {' '}
        <span className={cn(styles.toggle, autopayEnabled ? styles.on : styles.off)} onClick={() => autopay(userId, !autopayEnabled)}>
          {autopayEnabled ?
            <img src={toggle_on} alt="" />
            :
            <img src={toggle_off} alt="" />
          }
        </span>
      </div>
    </Box>
    <Warning name="autopay" />
  </React.Fragment>
);

const mapStateToProps = (state) => ({
  autopayEnabled: getAutopayEnabled(state),
  userId: getUser(state) && getUser(state).id,
});

const mapDispatchToProps = {
  autopay,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Autopay);
